import { isEqual } from 'lodash';
import { resolveAddedAndDeleted, extractQueryModelsParams, extractQueryModelsVariables } from '../../mixins/utils';
import AutoVarAliasesMixin from './AutoVarAliasesMixin';

export const DatasetWatchStoreMixin = {
    mixins: [AutoVarAliasesMixin],
    data: () => ({
        /**
         * @type {{ metrics: string[], dimensions: string[], fields: string[], variables: [] }}
         */
        queryParams: {
            metrics: [],
            dimensions: [],
            fields: [],
            variables: []
        }
    }),
    watch: {
        queryModels: {
            handler: '$queryUpdateParams',
            immediate: true // due to include like extra mixin in DatasetPanel
        },
        queryParams: {
            handler(newQueryParams, oldQueryParams) {
                const deletedParams = ['metrics', 'dimensions', 'fields', 'variables'].flatMap((paramType) => {
                    const [, deleted] = resolveAddedAndDeleted(newQueryParams[paramType], oldQueryParams[paramType]);
                    return deleted;
                });
                this.$storeRemoveVarAliases(deletedParams);
            }
        }
    },
    methods: {
        /**
         *
         * @param {import('@goodt-common/data').QueryModel[]} newQueryModels
         * @param {import('@goodt-common/data').QueryModel[]} [oldQueryModels=[]]
         */
        $queryUpdateParams(newQueryModels = this.queryModels = []) {
            /**
             * query model with pure dimensions with no hidden drill dimensions
             * @type {import('@goodt-common/data').QueryModelBase[]}
             */
            const queryModels = newQueryModels.filter(Boolean).map((queryModel) => queryModel.getBaseModel());
            const queryParams = ['variables', 'metrics', 'dimensions', 'fields'].reduce((acc, paramType) => ({
                ...acc,
                [paramType]: paramType === 'variables'
                    ? extractQueryModelsVariables(queryModels)
                    : extractQueryModelsParams(queryModels, [paramType])
            }), {});

            if (isEqual(queryParams, this.queryParams) === false) {
                this.queryParams = queryParams;
            }
        },
        /**
         * Update this.props.varAliases in elemInstance
         *
         * @param {string[]} deletedParams
         */
        $storeRemoveVarAliases(deletedParams) {
            // delete store map from props.varAliases
            if (deletedParams.length > 0) {
                deletedParams.forEach((paramName) => {
                    this.$storeMeta.deleteVar({ varAlias: paramName });
                });
                this.$storeMeta.saveVars();
            }
        }
    }
};
